import { Routes } from '@angular/router';

import { guestGuard } from '../../core/guards/guest.guard';

export const authPublicRoutes: Routes = [
  {
    path: 'inicio-sesion',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login').then((m) => m.AuthLogin),
  },
];

export const authAppRoutes: Routes = [
  {
    path: 'acceso-denegado',
    loadComponent: () => import('./pages/forbidden/forbidden').then((m) => m.AuthForbidden),
  },
];
